import _getIterator from 'babel-runtime/core-js/get-iterator';
import { findAll as findLinks } from './url';

export var capitalize = function capitalize(str) {
  str = str || '';
  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str;
};

export var hasOnlyDigits = function hasOnlyDigits(str) {
  if (typeof str !== 'string') {
    return false;
  }

  for (var i = 0, l = str.length; i < l; ++i) {
    if (isNaN(str[i])) {
      return false;
    }
  }

  return true;
};

/* check if the param string with 2 digits, i.e. : -3 will return false */
export var isStringWith2digitsOrMore = function isStringWith2digitsOrMore(value) {
  return typeof value === 'string' && value.length >= 2 && hasOnlyDigits(value);
};

export var extendPrototype = function extendPrototype() {
  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
};

export var random = function random() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  var text = '';
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < length; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return text;
};

export var replaceUrlsAndTwitterMentions = function replaceUrlsAndTwitterMentions(str) {
  var links = findLinks(str);
  if (!links) {
    return str;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(links), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var link = _step.value;

      str = str.replace(link.text, '<a href="' + link.url + '">' + link.text + '</a>');
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return str;
};
//# sourceMappingURL=string.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/string.js
// module id = 199
// module chunks = 0